class MatchRegistrationsController {
	constructor(
		MatchesFactory, PlayersFactory, TeamsFactory, $rootScope, $filter, $state, ngDialog, Permissions){
		'ngInject';
		const vm = this;

		let $translate = $filter('translate');

		vm.rootScope = $rootScope;

		vm.$onInit = () => {
			vm.players = [];
			vm.matchPlayers = [];
			vm.matchPlayersIds = [];
			vm.options = [
				{id: 1, name: 'ADD_REMOVE_PLAYERS'},
				{id: 3, name: 'CURRENT_PLAYERS'},
			];
			vm.filters = {};
			vm.filters.hasPaid = false;
			vm.teams = [];
			vm.activeTeam = null;
			if(vm.rootScope.user.isUserTypeTeam()){
				vm.activeTeam = vm.rootScope.currentUser;
				vm.reloadPlayers();
			}else if(vm.rootScope.user.isPremium() || vm.rootScope.user.canDo(Permissions.VIEW_ALL_TEAMS)){
				if(vm.rootScope.user.isPremium()){
					vm.options.push({id: 2, name: 'REMOVE_PLAYERS'});
				}
				TeamsFactory.getAll().then(response => {
					vm.teams = response.data;
				});
			}
			vm.filters = {
				sex: null,
				paymentsFulfilled: null,
			};
			vm.sexes = [
				{value: 'M', name: $translate('MALE')},
				{value: 'F', name: $translate('FEMALE')},
			];
			/* add - edit player match */
			vm.playerLeagues = null;
			vm.matchTeam = {};
			reloadMatchData();
		};

		vm.hasPermission = (permission) => {
			return vm.rootScope.user.canDo(permission);
		};

		vm.selectOption = (option) => {
			vm.activeOption = option;
			$state.current.data.hideSidebar = true;
		};

		vm.isPlayerRegistered = (playerId) => {
			return vm.matchPlayersIds.includes(playerId);
		};

		vm.isRegistrationOpen = () => {
			let now = new Date();
			let start = new Date(vm.rootScope.currentMatch.registration_start);
			let end = new Date(vm.rootScope.currentMatch.registration_end);
			return (now > start && now < end);
		};

		vm.addPlayersGridOptions = {
			enableSorting: true,
			enablePaginationControls: false,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [
				{
					field: 'playerName',
					enableFiltering: true,
					name: $translate('PLAYER_NAME'),
				}, {
					field: 'actions',
					enableFiltering: false,
					name: $translate('ACTIONS'),
					headerCellClass: 'text-center',
					cellTemplate: '' +
						'<div ' +
						'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
						'<div class="buttons">' +
						'<button class="btn btn-sm btn-success" translate ' +
						'data-toggle="modal" ' +
						'data-target="#playerMatchModal" ' +
						'ng-class="{disabled : !row.entity.matchEligibility.isEligible}" ' +
						'ng-click="grid.appScope.vm.openAddPlayerModel(row.entity.player_id)" ' +
						'ng-if="!grid.appScope.vm.isPlayerRegistered(row.entity.player_id)">ADD</button> ' +
						'<button class="btn btn-sm btn-warning" translate ' +
						'data-toggle="modal" ' +
						'data-target="#playerMatchModal" ' +
						'ng-click="grid.appScope.vm.openEditPlayerModel(row.entity.player_id)" ' +
						'ng-if="grid.appScope.vm.isPlayerRegistered(row.entity.player_id)">EDIT</button> ' +
						'<button class="btn btn-sm btn-danger" translate ' +
						'ng-click="grid.appScope.vm.removePlayer(row.entity.player_id)" ' +
						'ng-if="grid.appScope.vm.isPlayerRegistered(row.entity.player_id)">REMOVE</button> ' +
						'</div>' +
						'</div>',
					width: '340',
				},
			],
			onRegisterApi: function(gridApi){
				vm.addPlayersGridApi = gridApi;
			},
		};

		vm.matchPlayersGridOptions = {
			enableSorting: true,
			enablePaginationControls: false,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [
				{
					field: 'playerName',
					enableFiltering: true,
					name: $translate('PLAYER_NAME'),
				}, {
					field: 'teamName',
					enableFiltering: true,
					name: $translate('TEAM_NAME'),
				}, {
					field: 'leagueName',
					enableFiltering: true,
					name: $translate('LEAGUE_NAME'),
				}, {
					field: 'actions',
					enableFiltering: false,
					name: $translate('ACTIONS'),
					headerCellClass: 'text-center',
					cellTemplate: '' +
						'<div ' +
						'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
						'<div class="buttons">' +
						'<button class="btn btn-sm btn-danger" translate ' +
						'ng-click="grid.appScope.vm.removePlayer(row.entity.player_id)">REMOVE</button> ' +
						'</div>' +
						'</div>',
					width: '110',
				},
			],
		};

		vm.matchPlayersInfoGridOptions = {
			enableSorting: true,
			enablePaginationControls: false,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [
				{
					field: 'playerName',
					enableFiltering: true,
					name: $translate('PLAYER_NAME'),
				}, {
					field: 'teamName',
					enableFiltering: true,
					name: $translate('TEAM_NAME'),
				}, {
					field: 'leagueName',
					enableFiltering: true,
					name: $translate('LEAGUE_NAME'),
				},
			],
		};

		vm.clearSelections = () => {
			vm.currentMatchPlayer = null;
			vm.currentPlayer = null;
			vm.selectedLeague = null;
			vm.amea = false;
			vm.a_target = false;
		};

		/* Add Player */
		vm.openAddPlayerModel = (playerId) => {
			vm.currentPlayer = vm.players.find(player => {
				return player.player_id === playerId;
			});
			vm.playerLeagues = vm.currentPlayer.matchEligibility.leagues;
			vm.selectedLeague = null;
			vm.amea = false;
			vm.a_target = false;
		};
		vm.isAddPlayerValid = () => {
			return (vm.selectedLeague);
		};
		vm.addPlayerToMatch = () => {
			let leagueId = vm.selectedLeague.league_id;
			let playerId = vm.currentPlayer.player_id;
			let teamId = vm.currentPlayer.team_id;
			let data = {
				amea: vm.amea,
				a_target: vm.a_target,
			};
			if(vm.currentMatchPlayer){
				MatchesFactory.updatePlayerLeague(vm.rootScope.currentMatchId, playerId, leagueId, data)
							  .then(response => {
								  ngDialog.open({template: 'successTemplate'});
								  vm.clearSelections();
								  reloadMatchData();
							  });
			}else{
				MatchesFactory.addPlayer(vm.rootScope.currentMatchId, playerId, leagueId, teamId,
					data).then(response => {
					ngDialog.open({template: 'successTemplate'});
					vm.clearSelections();
					reloadMatchData();
				});
			}
		};

		/* Edit Player */
		vm.openEditPlayerModel = (playerId) => {
			vm.currentPlayer = vm.players.find(player => {
				return player.player_id === playerId;
			});
			vm.currentMatchPlayer = vm.matchPlayers.find(player => {
				return player.player_id === playerId;
			});
			vm.playerLeagues = vm.currentPlayer.matchEligibility.leagues;
			vm.amea = (vm.currentMatchPlayer.amea === 1);
			vm.a_target = (vm.currentMatchPlayer.a_target === 1);
			vm.selectedLeague = vm.playerLeagues.find(league => {
				return league.league_id === vm.currentMatchPlayer.league_id;
			});
		};

		/* Remove Player */
		vm.removePlayer = (playerId) => {
			ngDialog.openConfirm({
				template: 'confirmTemplate',
				data: {
					message: $translate('CONFIRM_REMOVE_PLAYER_FROM_MATCH'),
				},
			}).then(() => {
				MatchesFactory.removePlayer(vm.rootScope.currentMatchId, playerId).then(response => {
					ngDialog.open({template: 'successTemplate'});
					reloadMatchData();
				});
			});
		};

		/* Print */
		vm.printRegistrations = () => {
			vm.doanloading = true;
			let teamId = vm.activeTeam.team_id;
			//TODO
			if(vm.rootScope.currentUser.team_id){
				teamId = vm.rootScope.currentUser.team_id;
			}
			const tabWindowId = window.open('about:blank', '_blank');
			MatchesFactory.printsEntries(vm.rootScope.currentMatchId, teamId).then(response => {
				let file = new Blob([response.data], {type: 'application/pdf'});
				tabWindowId.location.href = window.URL.createObjectURL(file);
			});
		};

		/* Save Match Team Info */
		vm.saveMatchTeam = () => {
			let data = {
				captain: vm.matchTeam.captain,
				coach: vm.matchTeam.coach,
				companion: vm.matchTeam.companion,
			};
			MatchesFactory.updateTeamInformation(vm.rootScope.currentMatchId, vm.rootScope.currentUser.team_id, data)
						  .then(response => {
							  ngDialog.open({template: 'successTemplate'});
						  });
		};

		function reloadMatchData(){
			let data = {include: 'matchPlayers,matchTeams'};
			if(vm.rootScope.user.isUserTypeTeam()){
				data.team_id = vm.rootScope.currentUser.team_id;
			}
			MatchesFactory.getOne(vm.rootScope.currentMatchId, data)
						  .then(response => {
							  vm.matchPlayers = response.data.matchPlayers;
							  vm.matchPlayersGridOptions.data = vm.matchPlayers;
							  vm.matchPlayersInfoGridOptions.data = vm.matchPlayers;
							  vm.matchPlayersIds = [];
							  Object.entries(vm.matchPlayers).forEach(entry => {
								  vm.matchPlayersIds.push(entry[1].player_id);
							  });
							  if(vm.addPlayersGridApi){
								  vm.addPlayersGridApi.core.refresh();
							  }

							  if(response.data.matchTeams.length > 0){
								  vm.matchTeam = response.data.matchTeams[0];
							  }
						  });
		}

		vm.reloadPlayers = () => {
			let params = {};
			/* Has Paid For Year Filter */
			if(vm.filters.hasPaid){
				params.has_paid = 1;
			}
			params.team_id = vm.activeTeam.team_id;
			params.match_id = vm.rootScope.currentMatchId;
			PlayersFactory.getAll(params).then(response => {
				vm.players = response.data;
				vm.addPlayersGridOptions.data = vm.players;
			});
		};
	}
}

export default MatchRegistrationsController;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchProfile/matchRegistrations/matchRegistrations.controller.js